import React, { useRef } from 'react';
import i18n from '@i18next/i18n';
import Input from '@tencent/dui/lib/components/Input';
import Button from '@tencent/dui/lib/components/Button';
import DUIMobileSnackbar from '@tencent/dui-mobile/lib/components/Snackbar';
import DUISnackbar from '@tencent/dui/lib/components/Snackbar';
import { browser } from '@src/utils/agent';
import style from './style.less';
import { splitTextByGrapheme } from '@src/slide/domain/ui-model/utils/text-grapheme';
import { ImageValidator } from '@src/slide/application/service/copy-paste/core/cp-image.new/image-edit-manager/errors';

interface Props {
    text?: string;
    onTextChange: (text: string) => void;
    onImageChange: (image: { id: string, src: string }) => void;
    uploadImageCallback(files: Blob[]): Promise<{ id: string, src: string }[] | undefined>;
}
export default function CustomizeBullets(props: Props) {
    const { text = '', onTextChange, onImageChange, uploadImageCallback } = props;
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleClickBtn = async () => {
        if (!fileInputRef.current) {
            return;
        }
        fileInputRef.current.click();
    };
    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const { files } = event.nativeEvent.target as HTMLInputElement;
        if (!files || files.length < 1) {
            return;
        }
        const [valid, reason] = ImageValidator.checkImageBlob(files[0]);
        if (!valid) {
            // 如果图片非法，直接返回
            (browser.isMobile ? DUIMobileSnackbar : DUISnackbar)
                .show({ message: reason, type: 'info' });
            return;
        }
        const images = await uploadImageCallback(files as any);
        onImageChange({ id: images?.[0].id ?? '', src: images?.[0].src ?? '' });
    };

    const handleInputChange = (value: string, event: React.ChangeEvent<HTMLInputElement>) => {
        if ((event.nativeEvent as InputEvent).isComposing) {
            // 合成输入中，不打断合成输入
            onTextChange(value);
        } else {
            // 非合成输入，视为输入完成，只取最后一个字符
            onTextChange(splitTextByGrapheme(value).slice(-1)[0]);
        }
    };
    const handleCompositionEnd = (event: React.CompositionEvent<HTMLInputElement>) => {
        // 合成输入结束，只取最后一个字符
        onTextChange(splitTextByGrapheme(event.nativeEvent.data).slice(-1)[0]);
    };

    return (
        <div className={style['customize-bullets']}>
            <div className={style['customize-bullets-label']}>
                {i18n.t('自定义')}
            </div>
            <div className={style['customize-bullets-input-container']}>
                <Input
                    inputClassName={style['customize-bullets-input']}
                    value={text}
                    onChange={handleInputChange}
                    onCompositionEnd={handleCompositionEnd}
                />
                <Button
                    className={style['image-upload-btn']}
                    size="small"
                    onClick={handleClickBtn}
                >
                    {i18n.t('图片')}...
                </Button>
                <input
                    ref={fileInputRef}
                    hidden
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                />
            </div>
        </div>
    );
}
